const LIST_SHARE_NETWORKS = [
  {
    type: 'whatsapp',
    icon: 'whatsapp',
    name: 'Whatsapp',
    baseUrl: 'whatsapp://send'
  },
  {
    type: 'facebook',
    icon: 'facebook',
    name: 'Facebook',
    baseUrl: 'https://www.facebook.com/sharer/sharer.php'
  },
  {
    type: 'telegram',
    icon: 'telegram',
    name: 'Telegram',
    baseUrl: 'https://t.me/share/url'
  },
  {
    type: 'vkontakte',
    icon: 'vkontakte',
    name: 'ВКонтакте',
    baseUrl: 'https://vk.com/share.php'
  },
  {
    type: 'twitter',
    icon: 'x',
    name: 'X (Twitter)',
    baseUrl: 'https://twitter.com/share'
  }
];

export {LIST_SHARE_NETWORKS};

